import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * A shareable address for one order. The order opens in the Orders queue, beside the others,
 * as the Inbox does with a conversation.
 */
export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/orders/$orderId",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/app/$organizationSlug/orders",
			params: { organizationSlug: params.organizationSlug },
			search: { id: params.orderId },
		});
	},
});
